const navLinks = [
  {
    to: '/',
    text: 'Comics',
  },
  {
    to: '/characters',
    text: 'Characters',
  },
  {
    to: '/events',
    text: 'Events',
  },
  {
    to: '/creators',
    text: 'Creators',
  },
];

export default navLinks;
